import styled from "styled-components";


export const OuterLayout = styled.section `
    padding: 5rem 6rem;
    @media screen and (max-width: 1347px){
        padding: 5rem 9rem;
    }
    @media screen and (max-width: 1186px){
        padding: 5rem 5rem;
    }
    @media screen and (max-width: 990px){
        padding: 5rem 2.4rem;
    }
    @media screen and (max-width: 640px){
        padding: 5rem 1.5rem;
    }
`;
export const InnerLayout = styled.section `
    padding: 8rem 0;
`;